const { camelCase } = require('lodash');

function loadTheme() {
  try {
    const globalTheme = require('./global-theme');
    const tenantConfig = require('./static/tenant-config');
    const tenantTheme = tenantConfig?.theme || {};
    let theme = { ...globalTheme, ...tenantTheme };

    // convert kebab case to camel case
    theme = Object.keys(theme).reduce((acc, key) => {
      acc[camelCase(key)] = theme[key];
      return acc;
    }, {});

    return theme;
  } catch (err) {
    console.error('Failed to load theme config', err);
    throw err;
  }
}

module.exports = loadTheme;
